"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SpinNumberInput: true,
  MoneyInput: true,
  AmountInput: true,
  MaxAmountInput: true,
  withSpinButtons: true,
  withAproxValue: true
};
exports.SpinNumberInput = exports.MoneyInput = exports.MaxAmountInput = exports.AmountInput = void 0;
Object.defineProperty(exports, "withAproxValue", {
  enumerable: true,
  get: function get() {
    return _withAproxValue.withAproxValue;
  }
});
Object.defineProperty(exports, "withSpinButtons", {
  enumerable: true,
  get: function get() {
    return _withSpinButtons.withSpinButtons;
  }
});
var _BaseNumberInput = require("./BaseNumberInput");
Object.keys(_BaseNumberInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _BaseNumberInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BaseNumberInput[key];
    }
  });
});
var _withSpinButtons = require("./decorators/withSpinButtons");
var _withAproxValue = require("./decorators/withAproxValue");
var _withPrefixLabel = require("../decorators/withPrefixLabel");
var _withMax = require("./decorators/withMax");
/**
 * @param {import('./decorators/withSpinButtons').NumberInputWithSpinButtonsProps} props
 */
var SpinNumberInput = exports.SpinNumberInput = (0, _withSpinButtons.withSpinButtons)(_BaseNumberInput.BaseNumberInput);

/**
 * @typedef {import('./BaseNumberInput').BaseNumberInputProps} MoneyInputProps
 * @prop {string} symbol
 */

/**
 * @param {MoneyInputProps} props
 */
var MoneyInput = exports.MoneyInput = (0, _withPrefixLabel.withPrefixLabel)(_BaseNumberInput.BaseNumberInput, 'symbol');
var AmountInput = exports.AmountInput = (0, _withPrefixLabel.withPrefixLabel)((0, _withAproxValue.withAproxValue)(_BaseNumberInput.BaseNumberInput), 'symbol');
var MaxAmountInput = exports.MaxAmountInput = (0, _withMax.withMax)(_BaseNumberInput.BaseNumberInput);